import { Link } from 'react-router-dom';

const sections = [
  {
    title: 'Ábyrgðaraðili',
    body: 'Sundkortið ehf. (hér eftir „við") er ábyrgðaraðili persónuupplýsinga sem safnað er í tengslum við notkun á þjónustunni sundkortid.is. Við vinnum persónuupplýsingar í samræmi við lög nr. 90/2018 um persónuvernd og vinnslu persónuupplýsinga (GDPR-útfærsla).',
  },
  {
    title: 'Hvaða upplýsingar söfnum við',
    body: 'Við söfnum upplýsingum sem þú gefur okkur beint: nafn, netfang og lykilorð við skráningu. Við söfnum einnig notkunargögnum sjálfkrafa: tímasetningar heimsókna, sundlaugar sem notaðar eru, og upplýsingar um keypt sundkort. Greiðsluupplýsingar eru afgreiddar af greiðslugáttarleverandör og geymast ekki hjá okkur.',
  },
  {
    title: 'Tilgangur vinnslu',
    body: 'Persónuupplýsingarnar eru notaðar til að: veita þér aðgang að þjónustunni, afgreiða kaup og heimsóknir, senda staðfestingarpósta og þjónustutilkynningar, og uppfylla lagaskyldum okkar. Við notum upplýsingarnar ekki í markaðssetningu þriðja aðila.',
  },
  {
    title: 'Grundvöllur vinnslu',
    body: 'Vinnsla persónuupplýsinga byggist á: framkvæmd samnings (þjónustusamningur við notanda), lagalegri skyldu (bókhald, skattar), og lögmætum hagsmunum okkar (öryggi kerfisins, misnotkunarvarnir).',
  },
  {
    title: 'Geymsla og öryggi',
    body: 'Gögn eru geymd á öruggum netþjónum staðsettum innan Evrópska efnahagssvæðisins. Lykilorð eru geymd dulkóðuð með iðnaðarstaðli. Við beitum tækni- og skipulagstiltækum öryggisráðstöfunum til að vernda upplýsingarnar gegn óheimilum aðgangi.',
  },
  {
    title: 'Varðveislutími',
    body: 'Reikningsupplýsingar eru geymdar meðan á viðskiptasambandi stendur og í allt að 3 ár eftir að aðgangi er lokað, vegna lagalegra skyldna. Notkuarskrár (heimsóknir) eru geymdar í allt að 2 ár. Þú getur óskað eftir eyðingu gagna fyrr, sbr. réttindi hér að neðan.',
  },
  {
    title: 'Réttindi þín',
    body: 'Þú átt rétt á: aðgangi að þínum gögnum, leiðréttingu rangra upplýsinga, eyðingu gagna (að uppfylltum lagaskilyrðum), flutningi gagna á tæknilegu formi, og andmælum gegn ákveðinni vinnslu. Til að nýta þér réttindi þín skaltu hafa samband á: personuvernd@sundkortid.is',
  },
  {
    title: 'Kökur (cookies)',
    body: 'Við notum nauðsynlegar kökur til að halda innskráningarstöðu. Við notum engar markaðs- eða þriðja aðila mælingakökur án samþykkis þíns.',
  },
  {
    title: 'Kvartanir',
    body: 'Ef þú telur að vinnsla persónuupplýsinga þinna fari gegn lögum getur þú lagt fram kvörtun hjá Persónuvernd (www.personuvernd.is).',
  },
];

export function PersonuverndPage() {
  return (
    <div className="min-h-screen bg-white">
      {/* Header */}
      <header className="sticky top-0 z-50 bg-white/80 backdrop-blur-md border-b border-gray-100">
        <div className="max-w-7xl mx-auto flex items-center justify-between px-8 py-4">
          <Link to="/" className="flex items-center gap-3">
            <img src="/logo-no-text.png" alt="" className="h-9 w-auto" />
            <span className="text-xl font-title font-bold text-primary-800 tracking-wide">
              Sundkortið
            </span>
          </Link>
          <nav className="flex items-center gap-5">
            <Link
              to="/login"
              className="text-sm font-medium text-gray-500 hover:text-primary-700 transition-colors"
            >
              Innskráning
            </Link>
          </nav>
        </div>
      </header>

      {/* Content */}
      <main className="max-w-3xl mx-auto px-8 pt-20 pb-32">
        <p className="text-xs font-semibold tracking-[0.25em] uppercase text-primary-400 mb-4">
          Lagaleg skjöl
        </p>
        <h1 className="text-4xl md:text-5xl font-title font-bold text-primary-900 mb-4">
          Persónuverndarstefna
        </h1>
        <p className="text-sm text-gray-400 mb-14">
          Uppfært {new Date().toLocaleDateString('is-IS', { year: 'numeric', month: 'long', day: 'numeric' })}
        </p>

        <div className="space-y-10">
          {sections.map((s, i) => (
            <section key={i}>
              <h2 className="text-xl font-title font-semibold text-primary-900 mb-3">
                {s.title}
              </h2>
              <p className="text-gray-500 leading-relaxed">{s.body}</p>
            </section>
          ))}
        </div>
      </main>

      {/* Footer */}
      <footer className="bg-gray-50 border-t border-gray-100 py-12">
        <div className="max-w-7xl mx-auto px-8 flex flex-col md:flex-row items-center justify-between gap-4">
          <div className="flex items-center gap-3">
            <img src="/logo-no-text.png" alt="" className="h-6 w-auto opacity-30" />
            <span className="text-sm text-gray-400">
              &copy; {new Date().getFullYear()} Sundkortið
            </span>
          </div>
          <div className="flex flex-wrap justify-center gap-6 text-sm text-gray-400">
            <a href="tel:6956771" className="hover:text-gray-600 transition-colors">695 6771</a>
            <a href="mailto:info@seifur.is" className="hover:text-gray-600 transition-colors">info@seifur.is</a>
            <Link to="/skilmalar" className="hover:text-gray-600 transition-colors">Skilmálar</Link>
            <Link to="/personuvernd" className="hover:text-gray-600 transition-colors">Persónuvernd</Link>
          </div>
        </div>
      </footer>
    </div>
  );
}
